import type { JSX } from "react";
import type { SxProps } from "@mui/material";
import { Box } from "@mui/system";
import { forwardRef } from "react";


export type FormProps = Omit<JSX.IntrinsicElements["form"], "onSubmit" | "ref"> & {
	onSubmit?: VoidFunction;
	sx?: SxProps;
};

/**
 * Thin wrapper around a `<form>` component which handles preventing the default
 * event handling.
 */
export const Form = forwardRef<HTMLFormElement, FormProps>(({ onSubmit, ...formProps }, ref) => (
	<Box
		component="form"
		{ ...formProps }
		ref={ ref }
		onSubmit={ ev => {
			ev.preventDefault();
			ev.stopPropagation();
			onSubmit?.();
		} }
	/>
));